<template>
    <Dialog :value="value" @input="$listeners.input" title="CONFIRMAR E-MAIL" width="350" :buttons="buttons" show-close-button>
        <m-form ref="form" class="pt-4" @submit.prevent="enviar">
            <m-text-field ref="input"
                          id="FieldEmail"
                          label="E-mail"
                          class="required"
                          v-model="conf_email"
                          v-input-filter="[$filters.email]"
                          :rules="[$rules.required, $rules.email]"
                          maxlength="100"
                          outlined />
        </m-form>
    </Dialog>
</template>

<script>
  export default {
    name: 'DialogConfirmarEmail',
    props: { value: Boolean, email: String },
    data: () => ({
      conf_email: ''
    }),
    computed: {
      buttons () {
        return {
          Confirmar: () => this.enviar()
        }
      }
    },
    watch: {
      value (open) {
        if (open) {
          this.conf_email = this.email
        }
      }
    },
    methods: {
      enviar () {
        const form = this.$refs.form
        if (form.validate()) {
          this.$emit('input', false)
          this.$emit('enviar', this.conf_email)
        } else {
          return false
        }
      }
    }
  }
</script>

<style scoped>

</style>
